import { styled } from "goober";
import { Icon, type IconName } from "./Icon";
import { Link } from "./Link";
import { Tooltip } from "./Tooltip";

export const LinkFilterFooter = styled("div")`
  position: sticky;
  bottom: 12px;
  z-index: 3;
  align-self: center;
  flex-shrink: 0;
  margin-top: auto;
  margin-bottom: 12px;
  max-width: calc(100% - 24px);
  display: flex;
  align-items: center;
  gap: 2px;
  height: 32px;
  box-sizing: border-box;
  padding: 4px;
  border-radius: 9999px;
  background: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  box-shadow: var(--elevation-low);
`;

const FilterLink = styled(Link)`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 9999px;
  color: var(--text-secondary);
  cursor: pointer;

  &[data-selected="true"] {
    background: var(--alpha4);
    color: var(--text-primary);
  }
  &:hover {
    background: var(--alpha4);
    color: var(--text-primary);
  }
  &:focus-visible {
    outline: 2px solid var(--control-bg);
    outline-offset: 2px;
  }
`;

export function LinkFilterIconButton({
  to,
  selected,
  icon,
  label,
}: {
  to: string;
  selected: boolean;
  icon: IconName;
  label: string;
}) {
  return (
    <Tooltip content={label}>
      <FilterLink
        to={to}
        aria-label={label}
        data-selected={selected ? "true" : "false"}
      >
        <Icon name={icon} size={12} />
      </FilterLink>
    </Tooltip>
  );
}
